<div class="page">
  <h3>
    <b>{{ title }}</b>
  </h3>
  <div class="section-body mt-3">
    <div class="container" *ngIf="loading">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div
      class="container"
      *ngIf="!loading && !errorMessage && projects.length == 0"
    >
      <h4>No projects uploaded yet</h4>
    </div>
    <h4 class="alert alert-danger" *ngIf="!loading && errorMessage">
      {{ errorMessage }}
    </h4>
    <div class="row">
      <div class="col-lg-4 col-md-12" *ngFor="let project of projects">
        <div class="card">
          <div class="card-header">
            <h3 class="card-title">{{ project?.contractNo }}</h3>
          </div>
          <div class="card-body" id="collapseBasic">
            <span class="tag tag-blue mb-3">{{ project?.client }}</span>
            <p>{{ project?.formOfContract }}</p>
            <div class="row">
              <div class="col-5 py-1"><strong>Start Date:</strong></div>
              <div class="col-7 py-1">{{ project?.startDate }}</div>
              <div class="col-5 py-1"><strong>Completion Date:</strong></div>
              <div class="col-7 py-1">{{ project?.completionDate }}</div>
              <div class="col-5 py-1"><strong>Duration:</strong></div>
              <div class="col-7 py-1">
                <strong>{{ project?.duration }}</strong>
              </div>
              <div class="col-5 py-1"><strong>Maintenance Period</strong></div>
              <div class="col-7 py-1">
                <strong>{{ project?.maintenancePeriod }}</strong>
              </div>
            </div>
            <div class="card-footer">
              <div class="clearfix">
                <div class="float-left"><strong>15%</strong></div>
                <div class="float-right">
                  <small class="text-muted">Progress</small>
                </div>
              </div>
              <div class="progress progress-xs">
                <!-- [ngStyle]="{width: project.actualProgress + '%'}" -->
                <div
                  class="progress-bar bg-red"
                  role="progressbar"
                  style="width: 15%"
                  aria-valuenow="36"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </div>
            <div class="mainnavigation">
              <div class="card-footer">
                <a
                  href="#"
                  class="btn btn-block btn-success btn-sm"
                  routerLink="{{
                    '/project/' + project?.id + '/' + itemRouteSuffix
                  }}"
                  >{{ action || "View Project" }}</a
                >
                <a
                  class="btn btn-block btn-danger btn-sm"
                  (click)="onDeleteProject(confirmDg, project)"
                  >Delete</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #confirmDg let-confirmDialog>
  <div role="dialog">
    <div class="modal-header">
      <h4 class="modal-title pull-left">Delete Project</h4>
      <button
        type="button"
        class="close pull-right"
        aria-label="Close"
        (click)="confirmDialog.close('Close')"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p><strong>Are you sure you want to delete the project?</strong></p>
    </div>
    <div class="modal-footer">
      <button
        class="btn btn-danger btn-lg p-2 mr-2"
        (click)="confirmDialog.close('No')"
      >
        No
      </button>
      <button
        class="btn btn-success btn-lg p-2"
        (click)="confirmDialog.close('Yes')"
      >
        Yes
      </button>
    </div>
  </div>
</ng-template>
